import {
  RadioButtonGroupMapping,
  RadioButtonType,
} from '@labrav/react-components'

export const awsApprovedStatus: { [key: string]: string } = {
  Approved: 'Approved',
  Rejected: 'Rejected',
  'In review': 'In review',
  Submitted: 'Submitted',
  Draft: 'Draft',
}
export const stages: { [key: string]: string } = {
  Launched: 'Launched',
  'Closed Lost': 'Closed Lost',
  Prospect: 'Prospect',
  'Business Validation': 'Business Validation',
  Committed: 'Committed',
  'Technical Validation': 'Technical Validation',
  Qualified: 'Qualified',
}
export const leadStages: { [key: string]: string } = {
  Open: 'Open',
  Research: 'Prospect',
  Disqualified: 'Committed',
  Qualified: 'Qualified',
}

export const acceptanceStatusMapping: { [key: string]: string } = {
  Pending: 'Pending',
  Rejected: 'Rejected',
  Accepted: 'Accepted',
}

export const warningMapping: { [key: string]: string } = {
  'Attention needed': 'attention_needed',
  'Action required': 'action_required',
}

export enum TargetCloseDateRange {
  ALL = 'all',
  THREE_DAYS = '3days',
  SEVEN_DAYS = '7days',
  THIRTY_DAYS = '30days',
}
export enum LastUpdated {
  ALL = 'all',
  TWENTY_FOUR_HOURS = '24hours',
  THREE_DAYS = '3days',
  SEVEN_DAYS = '7days',
}
export const lastUpdatedsMapping: RadioButtonGroupMapping[] = [
  {
    key: LastUpdated.TWENTY_FOUR_HOURS,
    label: 'In 24 hours',
    type: RadioButtonType.STANDARD,
  },
  {
    key: LastUpdated.THREE_DAYS,
    label: 'In 3 days',
    type: RadioButtonType.STANDARD,
  },
  {
    key: LastUpdated.SEVEN_DAYS,
    label: 'In 7 days',
    type: RadioButtonType.STANDARD,
  },
  {
    key: LastUpdated.ALL,
    label: 'All time',
    type: RadioButtonType.STANDARD,
  },
]

export const targetCloseDateMapping: RadioButtonGroupMapping[] = [
  {
    key: TargetCloseDateRange.THREE_DAYS,
    label: 'Within 3 days',
    type: RadioButtonType.STANDARD,
  },
  {
    key: TargetCloseDateRange.SEVEN_DAYS,
    label: 'Within 7 days',
    type: RadioButtonType.STANDARD,
  },
  {
    key: TargetCloseDateRange.THIRTY_DAYS,
    label: 'Within 30 days',
    type: RadioButtonType.STANDARD,
  },
  {
    key: TargetCloseDateRange.ALL,
    label: 'All time',
    type: RadioButtonType.STANDARD,
  },
]
